import { useStateContext } from '../modules/stateContext';

export function useViewabilityEvents() {
    const {
        featureToggles: { tvCodeViewabilityEvents, viewabilityEvents },
        journeyGroupType,
    } = useStateContext();

    const applyTvCodeViewabilityEvents = !!(
        tvCodeViewabilityEvents && journeyGroupType !== undefined
    );

    const applyViewabilityEvents = !!(
        viewabilityEvents && journeyGroupType !== undefined
    );

    return {
        applyTvCodeViewabilityEvents,
        applyViewabilityEvents,
    };
}
